export default "__VITE_ASSET__DDB1uksW__"